import { ENGLISH_IQ_SUB_BANDS } from '@repo/config';

interface IEnglishIqScorePosition {
  maxScore: number;
  minScore: number;
  progress: number;
}

export function getEnglishIqScorePosition(score: number): IEnglishIqScorePosition {
  const minScore = ENGLISH_IQ_SUB_BANDS[0].minScore;
  const maxScore = ENGLISH_IQ_SUB_BANDS.at(-1)?.maxScore ?? minScore;
  const span = Math.max(1, maxScore - minScore);
  const clamped = Math.min(Math.max(score, minScore), maxScore);
  return {
    maxScore,
    minScore,
    progress: ((clamped - minScore) / span) * 100,
  };
}
